'use strict';

module.exports = new function()
{
    let me = this;

    me._number = function(number, decimals, thousands_sep, dec_point)
    {
        let i, j, kw, kd, km;

        if(decimals !== false) decimals = 2;
        else decimals = 0;

        if(dec_point == undefined) dec_point = ".";

        if(thousands_sep == undefined) thousands_sep = " ";

        i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

        if((j = i.length) > 3 ) j = j % 3;
        else j = 0;

        km = (j ? i.substr(0, j) + thousands_sep : "");
        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
        kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

        return km + kw + kd;
    };

    me.toLatin = function(string, separator)
    {
        separator = separator == undefined ? "-" : 	separator;

        const order =
            {
                "а": "a",
                "б": "b",
                "в": "v",
                "г": "g",
                "д": "d",
                "е": "e",
                "ё": "e",
                "ж": "zh",
                "з": "z",
                "и": "i",
                "й": "y",
                "к": "k",
                "л": "l",
                "м": "m",
                "н": "n",
                "о": "o",
                "п": "p",
                "р": "r",
                "с": "s",
                "т": "t",
                "у": "u",
                "ф": "f",
                "х": "h",
                "ц": "c",
                "ч": "ch",
                "ш": "sh",
                "щ": "sh",
                "ъ": "",
                "ы": "i",
                "ь": "",
                "э": "e",
                "ю": "u",
                "я": "ya",

                "А": "A",
                "Б": "B",
                "В": "V",
                "Г": "G",
                "Д": "D",
                "Е": "E",
                "Ё": "E",
                "Ж": "ZH",
                "З": "Z",
                "И": "I",
                "Й": "Y",
                "К": "K",
                "Л": "L",
                "М": "M",
                "Н": "N",
                "О": "O",
                "П": "P",
                "Р": "R",
                "С": "S",
                "Т": "T",
                "У": "U",
                "Ф": "F",
                "Х": "H",
                "Ц": "C",
                "Ч": "CH",
                "Ш": "SH",
                "Щ": "SH",
                "Ъ": "",
                "Ы": "I",
                "Ь": "",
                "Э": "E",
                "Ю": "U",
                "Я": "Ya",

                " ": separator
            };

        string = me.trim(string);
        let translit = "";

        for (let i = 0; i < string.length; i++)
        {
            if(separator == string.charAt(i)) translit += separator;
            else if(/[а-яёА-ЯЁ ]/.test(string.charAt(i))) translit += order[string.charAt(i)];
            else if(/[a-z0-9A-Z ]/.test(string.charAt(i))) translit += string.charAt(i);
        }

        return translit;
    };

    me.round = function(number, digits)
    {
        number *= 1;

        if(number) return number.toFixed(digits) * 1;
        else return parseInt(number);
    };

    me.getNumber = function(number, digits)
    {
        return me._number(number, digits);
    };

    me.getMoney = function(number, digits, label, separate)
    {
        digits = ((digits == false || digits == undefined) && digits !== false) ? 2 : digits;
        label = (label == false || label == undefined) ? "" : "руб.";
        separate = (separate == false || separate == undefined) ? "," : "";

        if(number == 0)
        {
            if(label) return 0 + " " + label;
            else return 0;
        }

        let money = me._number(number, digits, separate);

        if(label) money = money + " " + label;

        return money;
    };

    me.getMoneyNumber = function(number, digits)
    {
        digits = (digits == false || digits == undefined && digits !== false) ? 2 : 0;
        return parseFloat(me._number(number, digits));
    };

    me.trim = function(str, charlist)
    {
        charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
        const re = new RegExp('^[' + charlist + ']+|[' + charlist + ']+$', 'g');
        return str.replace(re, '');
    };
};
